import Carousel from '@glass/web/components/Carousel/Carousel';
import useCarouselResponsiveProps from '@glass/web/components/Carousel/useCarouselResponsiveProps';
import Testimonial, {
  TestimonialProps,
} from '@glass/web/components/TestimonialSection/Testimonial';
import useLoadingResources from '@glass/web/modules/resources/useLoadingResources';
import { SM, XS } from '@glass/web/modules/theme/breakpointKeys';
import makeStyles from '@glass/web/modules/theme/makeStyles';

export const TESTIMONIAL_CAROUSEL_BREAKPOINT_PROPS = {
  [XS]: {
    visibleSlides: 1,
    step: 1,
  },
  [SM]: {
    visibleSlides: 2,
    step: 1,
  },
  default: {
    visibleSlides: 4,
    step: 2,
  },
};

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },
});

interface TestimonialCarouselProps {
  hasButtons: boolean;
  onHover?: () => void;
  testimonials: TestimonialProps[];
  isLoading: boolean;
}

function TestimonialCarousel({
  hasButtons,
  onHover,
  testimonials: testimonialsProp,
  isLoading,
}: TestimonialCarouselProps) {
  const { visibleSlides: slidesToShow } = useCarouselResponsiveProps(
    TESTIMONIAL_CAROUSEL_BREAKPOINT_PROPS,
  );
  const { classes } = useStyles();

  const loadingTestimonials = useLoadingResources<TestimonialProps>(4, {
    key: 'date',
  });

  const testimonials =
    isLoading && !testimonialsProp?.length ? loadingTestimonials : testimonialsProp;

  return (
    <div onMouseEnter={onHover} className={classes.root}>
      <Carousel
        shouldAutoPlay={false}
        breakpointProps={TESTIMONIAL_CAROUSEL_BREAKPOINT_PROPS}
        slidesToShow={slidesToShow}
        hasButtons={hasButtons}
      >
        {testimonials.map(({ date, firstName, lastName, quote, rating }) => (
          <Testimonial
            key={date}
            id={date}
            firstName={firstName}
            lastName={lastName}
            quote={quote}
            rating={rating}
            isLoading={isLoading}
          />
        ))}
      </Carousel>
    </div>
  );
}

export default TestimonialCarousel;
